import { Options, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { FormMixin } from "@/mixins/form/FormMixin";
import { Router } from "vue-router";

@Options({})
export class FormCreateMixin extends mixins(FormMixin) {
  protected resource?: string;
  protected updateRouteName?: string;
  protected createAction: any;
  protected item?: any;
  protected success: any;

  protected async onSubmit(item: any): Promise<void> {
    await this.createActionFn(item);
    if (this.updateRouteName && this.success && this.item?.id) {
      await this.$router.replace({
        name: this.updateRouteName,
        params: { id: this.item.id },
      });
    } else {
      this.goBack();
    }
  }

  protected async createActionFn(item: any) {
    await this.createAction({
      resource: this.resource,
      data: item,
    });
  }
}
